<template>
    <b-modal
        :no-close-on-backdrop="true"
        modal-class="modals-approval gofixModal"
        size="lg"
        title="Approval"
        hide-footer
        :centered="true"
        ref="modal-approval-log"
        v-model="modals.approval.open">
        <div class="actionAndRemarks modalPadding" v-bind:class="{'disabled-block':checkRoleApproval()}">
            <b-row>
                <b-col md="12" class="mb-3" v-if="activeApprovalRoute && pvItem && (pvItem.status === 'Under Approval' || pvItem.status === 'Pending Revision' || pvItem.status === 'Draft')">
                    <gofix-text-field label="Next Approver" oneline>
                        <span v-if="pvItem.total < activeApprovalRoute.finance_limit">--</span>
                        <span v-else> {{modals.approval.approverNext.limit| formatMoney}} - {{modals.approval.approverNext.user}} </span>
                    </gofix-text-field>
                </b-col>
                <b-col md="12" class="mb-3" v-if="pvItem && (pvItem.status === 'Under Approval' || pvItem.status === 'Pending Revision' || pvItem.status === 'Draft')">
                    <gofix-text-field label="Current Approver" oneline>
                        <span v-if="pvItem.status === 'Draft'">--</span>
                        <span v-else>{{modals.approval.approverCurrent.limit| formatMoney}} - {{modals.approval.approverCurrent.user ? modals.approval.approverCurrent.user : ''}}</span>
                    </gofix-text-field>
                </b-col>
                <b-col md="9" class="">
                    <gofix-form-input-textarea label="remarks" class="mb-0 h-100" v-model="modals.approval.data.remark"></gofix-form-input-textarea>
                </b-col>
                <b-col md="3" class="action">
                    <gofix-button
                        class="d-block mb-2 w-100"
                        :label="pvItem.status === 'Pending Revision' ? 'Revision Applied':'Recommend for Approval'"
                        @click="approvalPV('Recommend for Approval')"
                        :disabled="checkRoleApproval() || (pvItem.status !== 'Draft' && activeApprovalRoute && (activeApprovalRoute.sequence == pvItem.approval_levels.length)) || modals.approval.loading"
                        v-if="activeApprovalRoute && (pvItem.total > activeApprovalRoute.finance_limit || (pvItem && (pvItem.status === 'Draft' || (pvItem.status === 'Pending Revision' && pvItem.approval_current_level < 0)) && !checkInRoleApproval()))"
                        outline />
                    <gofix-button
                        class="d-block mb-2 w-100"
                        label="Approve"
                        @click="approvalPV('Approval')"
                        v-if="activeApprovalRoute && pvItem.total <= activeApprovalRoute.finance_limit && checkInRoleApproval()"
                        :disabled="checkRoleApproval() || modals.approval.loading"
                        outline />
                    <gofix-button
                        class="d-block mb-2 w-100"
                        label="Request for Revision"
                        @click="approvalPV('Request for Revision')"
                        v-if="parseInt(pvItem.approval_current_level) >= 0 && pvItem.approval_current_level !== null && (pvItem.status === 'Under Approval' || pvItem.status === 'Pending Revision')"
                        :disabled="checkRoleApproval() || modals.approval.loading"
                        outline />
                    <gofix-button
                        class="d-block w-100"
                        label="Reject"
                        @click="approvalPV('Reject')"
                        :disabled="checkRoleApproval() || modals.approval.loading"
                        v-if="pvItem && (pvItem.status !== 'Draft' || (pvItem.status === 'Draft' && !checkRoleApproval())) && checkInRoleApproval()"
                        outline dark></gofix-button>
                    <gofix-button
                        class="d-block w-100"
                        label="Cancel"
                        @click="modals.approval.open = false"
                        v-if="pvItem && pvItem.status === 'Draft' && checkRoleApproval() || (pvItem.approval_current_level <= 0 && !checkInRoleApproval())"
                        outline dark />
                </b-col>
            </b-row>
        </div>
        <hr/>
        <b-row>
            <b-col md="12" class="mb-3">
                <h5 class="modalTitle modalPadding">Approval Log</h5>
            </b-col>
            <b-col md="12">
                <div class="gofixBasicTable approvalLogTable">
                    <div class="dataList">
                        <vue-scrollbar class="tableList">
                            <b-table :fields="modals.approval.approvalLogs.field" :items="modals.approval.approvalLogs.data" class="table-has-fixed" fixed>
                                <template slot="finance_limit" slot-scope="row">
                                    {{ row.item.finance_limit | formatMoney}}
                                </template>
                                <template slot="log_time" slot-scope="row">
                                    {{ row.item.log_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                                </template>
                            </b-table>
                        </vue-scrollbar>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'modal-approval-payment',
        data () {
            return {
                id: null,
                modals: {
                    approval:{
                        open:false,
                        loading:false,
                        data:{
                            remark:null,
                            action: null,
                            approval_route_id: null,
                            offset_id: null
                        },
                        approvalLogs:{
                            data: [],
                            field:[
                                {
                                    key: 'approval_route_level',
                                    label: 'Route Lvl',
                                    thStyle: 'width: auto'
                                },
                                {
                                    key: 'log_time',
                                    label: 'Time',
                                    thClass: 'text-center',
                                    tdClass: 'text-center',
                                    thStyle: 'width: 170px'
                                },
                                {
                                    key: 'action',
                                    label: 'Action',
                                    thStyle: 'width: 170px',
                                },
                                {
                                    key: 'reviewer.name',
                                    label: 'Reviewer',
                                    thStyle: 'width: 170px',
                                },
                                {
                                    key: 'remark',
                                    label: 'Remarks',
                                    thStyle: 'width: 170px',
                                },
                            ],
                            loading: false
                        },
                        approvalRoute:[],
                        approverNext: {
                            limit: 0,
                            user: null,
                            ids:[]
                        },
                        approverCurrent: {
                            limit: 0,
                            user: null,
                            ids:[]
                        }
                    }
                }
            };
        },
        computed: {
            activeApprovalRoute(){
                let current_index = (this.pvItem.approval_current_level && this.pvItem.approval_current_level >=0) ? this.pvItem.approval_current_level : 0;
                if(!this.pvItem.approval_levels) return [];
                return this.pvItem.approval_levels[current_index];
            },
            ...mapGetters({
                pvItem: "OffsetDocumentController/Item",
                UserLogged : 'AuthController/user'
            }),
        },
        watch: {
            pvItem: function(val) {
                if(val) {
                    this.openModalApproval();
                }
            }
        },
        methods: {
            getData(id) {
                if(id) {
                    this.id = id;
                    this.modals.approval.data.offset_id = id;
                    this.getPV();
                    this.getPvApprovalLogs();
                    this.getNextApprover();
                    this.getApprovalLogTableSetting();
                }
            },
            getPV(){
                this.$store.dispatch('OffsetDocumentController/getPayment', this.id);
            },
            getPvApprovalLogs(){
                let params = {
                    page: 1,
                    limit: -1,
                    filter:{
                        offset_id :  this.id
                    }
                }
                this.$store.dispatch('OffsetDocumentController/getApprovalLogs',params)
                    .then(response => {
                        this.modals.approval.approvalLogs.data = response.items;
                        this.total_approval_log = this.modals.approval.approvalLogs.data.length;
                    })
                    .catch(err => {
                        this.modals.approval.approvalLogs.data = [];
                        console.log(err)
                    })
            },
            getApprovalLogTableSetting(){
                this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
                    user_id: 0,
                    table_name: "work-order-approval-log"
                }).then(response => {
                    this.modals.approval.approvalLogs.field = response.data.data.settings.fields
                }).catch(error => {})
            },
            getNextApprover(){
                this.$store.dispatch("OrderApprovalLogController/getNextApprover",{
                    offset_id: this.id,
                }).then(response => {
                    this.modals.approval.approverNext.user = response.next.user_name ? response.next.user_name.join(", ") : null;
                    this.modals.approval.approverNext.ids = response.next.user_ids;
                    this.modals.approval.approverNext.limit = response.next.finance;

                    this.modals.approval.approverCurrent.user = response.current.user_name ? response.current.user_name.join(", ") : null;
                    this.modals.approval.approverCurrent.ids = response.current.user_ids;
                    this.modals.approval.approverCurrent.limit = response.current.finance;

                })
                .catch( err => {
                    this.modals.approval.approverNext.user = null;
                    this.modals.approval.approverNext.ids = [];
                    this.modals.approval.approverNext.limit = null;

                    this.modals.approval.approverCurrent.user = null;
                    this.modals.approval.approverCurrent.ids = [];
                    this.modals.approval.approverCurrent.limit = null;
                })
            },
            checkRoleApproval(approval = false){
                if(!this.activeApprovalRoute || ((this.pvItem.status === "Draft" && this.modals.status.data.status === "Under Approval") || (this.pvItem.status === "Pending Revision" && this.pvItem.approval_current_level < 0))) return false;
                if(!this.activeApprovalRoute || (this.pvItem.status !== "Under Approval" && this.pvItem.status !== 'Pending Revision')) return true;
                //let userRoles = this.UserLogged.roles.map(a => a.id);
                if(this.checkInRoleApproval()){
                    return false;
                }
                return true;
            },
            openModalApproval(){
                if(this.pvItem && this.pvItem.get_line_items && this.pvItem.get_line_items.length !== 0){
                    this.modals.approval.open = true
                }else{
                    this.$alertNotification("Please add a offset line item to approval", "warning");
                }
            },
            checkInRoleApproval(){
                let userRoles = this.UserLogged.roles ? this.UserLogged.roles.map(a => a.id) : [];
                if(this.activeApprovalRoute && this.activeApprovalRoute.roles){
                    let roles     = this.activeApprovalRoute.roles.map(a => a.id);
                    const arrTmp  = userRoles.filter(item => roles.includes(item));
                    if(arrTmp.length) {
                        return true;
                    }
                }
                return false;
            },
            approvalPV(action){
                if(!this.activeApprovalRoute || this.modals.approval.loading) return;
                this.modals.approval.data.action = action;
                this.modals.approval.data.approval_route_id = this.activeApprovalRoute.id;
                this.modals.approval.loading = true;
                //createApprovalLogs
                this.$store.dispatch(`OffsetDocumentController/createApprovalLogs`, this.modals.approval.data)
                    .then( response => {
                        this.modals.approval.loading = false;
                        this.modals.approval.open = false;
                        this.getPvApprovalLogs();
                        this.getNextApprover();
                        this.$alertNotification(this.$notificationV2('adding', 'approval'));
                    })
                    .catch(error => {
                        console.log(error)
                        this.modals.approval.loading = false;
                        this.$alertNotification(`Can't "${action}"`, "warning");
                    });
            },
        }
    }
</script>